export default "__VITE_ASSET__atHP1MfW__"